import { computed } from "vue";
import { START_LOCATION, useRouter } from "vue-router";

export const useRouterReady = () => {
  const router = useRouter();
  return computed(() => router.currentRoute.value !== START_LOCATION);
};
